import {
  getTranslation,
  Resources,
} from "Infrastructure/Translations/Resources";
import type { BlOption } from "Shared/Inputs/BlOption";

export const languageFilterOptions = (): BlOption[] => [
  { value: "", label: getTranslation(Resources.Actors.AllLanguages) },
  { value: "Czech", label: getTranslation(Resources.Common.Languages.Czech) },
  {
    value: "English",
    label: getTranslation(Resources.Common.Languages.English),
  },
  {
    value: "Deutsch",
    label: getTranslation(Resources.Common.Languages.Deutsch),
  },
];

export const ageFilterOptions = (): BlOption[] => [
  { value: "", label: getTranslation(Resources.Actors.AllAges) },
  { value: "18-30", label: "18-30" },
  { value: "31-45", label: "31-45" },
  { value: "46-60", label: "46-60" },
];

export const sexFilterOptions = (): BlOption[] => [
  { value: "", label: getTranslation(Resources.Actors.AllSexes) },
  { value: "Male", label: getTranslation(Resources.Actors.Male) },
  { value: "Female", label: getTranslation(Resources.Actors.Female) },
];

export const priceFilterOptions = (): BlOption[] => [
  { value: "", label: getTranslation(Resources.Actors.AllPrices) },
  { value: "low", label: `< 5 000 €` },
  { value: "medium", label: `5 000 - 10 000 €` },
  { value: "high", label: `> 10 000 €` },
];
